<template>
    <div class="wrapper">

        <v-dialog
                transition="dialog-bottom-transition"
                max-width="600"
                v-model="dangerModal"
        >
            <template v-slot:default>
                <v-card>
                    <v-toolbar
                            color="error"
                            dark

                    >{{title}}
                    </v-toolbar>
                    <v-card-subtitle class="text-right">
                        <div class="text-h6 p-1 text-right">{{message_api}}</div>
                    </v-card-subtitle>
                    <v-card-actions class="justify-end">
                        <v-btn
                                text
                                @click="dangerModal = false"
                        >بستن
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
                transition="dialog-bottom-transition"
                max-width="600"
                v-model="successModal"

        >
            <template v-slot:default>
                <v-card>
                    <v-toolbar
                            color="success"
                            dark

                    >{{title}}
                    </v-toolbar>
                    <v-card-subtitle class="text-right">
                        <div class="text-h6 p-1 text-right">{{message_api}}</div>
                    </v-card-subtitle>
                    <v-card-actions class="justify-end">
                        <v-btn
                                text
                                @click="successModal = false"
                        >Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <!-- Modal Component -->

        <v-dialog
                transition="dialog-bottom-transition"
                max-width="600"
                v-model="confirmModal"

        >
            <template >
                <v-card>
                    <v-toolbar
                            color="primary"
                            dark
                    >{{title}}
                    </v-toolbar>
                    <v-card-subtitle class="text-right">
                        <div class="text-h6 p-1 text-right">{{message_confirm}}</div>
                    </v-card-subtitle>
                    <v-card-actions class="justify-end">
                        <v-btn
                                text
                                @click="confirmed_request(false)"
                        >انصراف
                        </v-btn>
                        <v-btn
                                text
                                @click="confirmed_request(true)"
                        >تایید
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>


    </div>

</template>

<script>
    import { bus } from '../../main'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/theme-sugar.css'

    Vue.use(VueToast)
    export default {
        name: 'Modals',
        data () {
            return {

                dangerModal: false,
                successModal: false,
                confirmModal: false,
                spinnerModal: false,
                fixedToasts: 0,
                alertCountDown: true,
                alertSecs: 3,
                alert_color: 'info',
                confirmed_request_tag: '',
                title: '',
                title2: 'salam hamid',
                message_api: '',
                message: '',
                message_confirm: '',

                buttons: [],
                buttons_onclick: [],
            }
        },
        mounted () {
            bus.$on('show_spinner', (data) => {
                if (data == 'true') {
                    try {
                        this.$root.loading_component.loading = true
                    } catch (e) {
                        console.log('error at show loading')
                    }
                } else {
                    try {
                        this.$root.loading_component.loading = false
                    } catch (e) {
                        console.log('error at show loading')
                    }
                }
            })

        },
        methods: {
            show_danger_modal (title, text) {
                console.log("danger modal called")
                this.title = title
                this.message_api = text
                // this.buttons = buttons;
                this.dangerModal = true
            },
            show_loading_modal () {

                this.spinnerModal = true
            },
            show_success_modal (title, text) {
                this.title = title
                this.message_api = text
                this.successModal = true
            },
            show_warning_notif(string){
                Vue.$toast.open({
                    message: string,
                    type: 'error',
                })
            },
            show_api_response_modals (res_data) {
                if (res_data.data.error != 0) {
                    this.alert_color = 'danger'
                    this.message_api = res_data.data.msg
                    this.title = "خطا"
                    Vue.$toast.open({
                        message: res_data.data.msg,
                        type: 'error',
                    })

                } else {
                    this.alert_color = 'success'
                    this.message_api = res_data.data.msg
                    this.title = 'تایید'
                    Vue.$toast.open({
                        message: res_data.data.msg,
                        type: 'success',
                    })
                }
            },

            show_validate_errors (errors) {
                this.alert_color = 'danger'
                var message = ''
                for (var xz = 0; xz < errors.length; xz++) {
                    message = message + '\n' + errors[xz]
                }
                Vue.$toast.open({
                    message: message,
                    type: 'error',
                    duration: 5000
                })
            },
            show_confirm_modal (title, text, buttons, bus_tag) {
                this.title = title
                this.message_confirm = text
                this.buttons = buttons
                this.confirmed_request_tag = bus_tag
                this.confirmModal = true
            },
            confirmed_request (status) {
                this.confirmModal = false
                if (status) {
                    bus.$emit(this.confirmed_request_tag, 'true')
                    this.confirmed_request_tag = ''
                } else {
                    bus.$emit(this.confirmed_request_tag, 'false')
                    this.confirmed_request_tag = ''
                }
            }
        }

    }
</script>
